var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHealthyEating = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fruit-Apple--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fruit Apple Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 6a6.91 6.91 0 0 0 -2.66 0.41 0.24 0.24 0 0 1 -0.23 0 0.23 0.23 0 0 1 -0.11 -0.2V5.5a3 3 0 0 0 -3 -3H8a1 1 0 0 0 0 2h2a1 1 0 0 1 1 1v0.68a0.23 0.23 0 0 1 -0.11 0.2 0.24 0.24 0 0 1 -0.23 0A6.91 6.91 0 0 0 8 6c-3.36 0 -6 3.29 -6 7.5C2 17.46 5 24 8.5 24c1.8 0 2.33 -0.34 2.79 -0.75A0.81 0.81 0 0 1 12 23a0.81 0.81 0 0 1 0.71 0.25c0.46 0.41 1 0.75 2.79 0.75C19 24 22 17.46 22 13.5 22 9.29 19.36 6 16 6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 5.41A5 5 0 0 0 19 1.16a1 1 0 0 0 -0.34 -0.86 1 1 0 0 0 -0.86 -0.3 5 5 0 0 0 -4.25 4.26 1 1 0 0 0 1.15 1.15Zm-0.07 -0.49Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHealthyEating);
export default ForwardRef;